import React, { useEffect, useState } from "react";
import { Col, Form, Row, Card, Stack } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import Loader from "../../../components/common/Loader";
import { getCategoryDetails } from "../../../services/categoryService";
import CustomView from "../../../components/common/CustomView";
import { CgMenuGridR } from "react-icons/cg";

export const View = () => {
  const location = useLocation();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      setLoading(true);
      getCategoryDetails(id).then(
        (resp) => {
          const res = resp?.data;
          setData(res);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        },
        (error) => {
          const err = error?.response?.data;
          setLoading(false);
          if (err?.statusCode === 400) {
            toast.error(err.msg);
            navigate(nameBasedProtectedRoutes.category.path);
          }
        }
      );
    }
  }, [id]);

  return (
    <>
      <div className="d-flex flex-column pageContainer p-3 h-100 overflow-auto">
        <div className="flex-grow-1 pageContent position-relative pt-4">
          <Card className="h-100 bg-white shadow border-0 theme-card-cover">
            <div className="theme-card-header px-1">
              <Stack
                direction="horizontal"
                gap={2}
                className="flex-wrap justify-content-between px-3 pt-3 pb-2 align-items-start"
              >
                <h5 className="mb-0 position-relative fw-medium">
                  <div className="align-items-center bg-primary d-inline-flex h-60 justify-content-center  position-absolute rounded start-0 text-white theme-icon-box w-60 z-1">
                    <CgMenuGridR size={40} />
                  </div>
                  Category Details
                </h5>

                <Link
                  to={nameBasedProtectedRoutes.category.path}
                  className="btn btn-primary mw-84"
                >
                  Back
                </Link>
              </Stack>
            </div>

            {!loading && data ? (
              <div className="franchiseDtl">
                <Row className="py-4 border-grey">
                  <Col sm={6} lg={4} xl={3}>
                    <Form.Group className="pb-1 lh-sm">
                      <Form.Label className="mb-1 fw-normal labelColor fs-13">
                        Category Name
                      </Form.Label>
                      <div className="static-data fs-16">{data.name}</div>
                    </Form.Group>
                  </Col>
                  <Col sm={6} lg={4} xl={3}>
                    <CustomView
                      label="Type"
                      value={data.category_type}
                      type="text"
                      capital={true}
                    />
                  </Col>
                  <Col sm={6} lg={4} xl={3}>
                    <CustomView
                      label="Current Status"
                      value={data.status}
                      type="text"
                      capital={true}
                    />
                  </Col>
                </Row>
                <Row className="py-4 border-grey">
                  <Col sm={6} lg={4} xl={4}>
                    <CustomView
                      label="Description"
                      value={data.description}
                      type="text"
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              ""
            )}
            <Loader isLoading={loading} />
          </Card>
        </div>
      </div>
    </>
  );
};
